module.exports = __webpack_public_path__ + "static/vegetarian-61be675cbbf795c3d06cd471d851082b.png";